import Component from '@glimmer/component';
import Chip from 'tio-reimagined/components/chip';
import type Report from 'tio-data/models/reports';

interface ReportStatusBadgeSignature {
  Args: {
    report?: Report;
    hasUnsavedChanges?: boolean;
  };
  Element: HTMLDivElement;
}

export default class ReportStatusBadge extends Component<ReportStatusBadgeSignature> {
  get saveStateIntent(): 'success' | 'warning' | 'default' {
    if (!this.args.report) return 'default';
    if (this.args.hasUnsavedChanges) return 'warning';
    return 'success';
  }

  get saveStateLabel(): string {
    if (!this.args.report) return 'New';
    if (this.args.hasUnsavedChanges) return 'Unsaved Changes';
    return 'Saved';
  }

  get scopeIntent(): 'primary' | 'default' {
    return this.args.report?.isPublished ? 'primary' : 'default';
  }

  get scopeLabel(): string {
    if (!this.args.report) return '';
    return this.args.report.isPublished ? 'Published' : 'Unpublished';
  }

  get visibilityLabel(): string {
    if (!this.args.report) return '';
    return this.args.report.visibilityLabel;
  }

  <template>
    <div class="tio-row-tight" data-test-report-status-badge ...attributes>
      <Chip @intent={{this.saveStateIntent}} @size="sm">
        {{this.saveStateLabel}}
      </Chip>
      {{#if @report}}
        <Chip @intent={{this.scopeIntent}} @size="sm">
          {{this.scopeLabel}}
        </Chip>
        <span class="text-xs text-gray-500 dark:text-gray-400">
          {{this.visibilityLabel}}
        </span>
      {{/if}}
    </div>
  </template>
}
